import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Warning from "@material-ui/icons/Warning";
import styles from "assets/jss/style-component/views/dashboardStyle.js";
import { Card, CardFooter, CardHeader, CardIcon } from "components";
import Danger from "components/Typography/Danger.js";
import { ArrowForwardIcon } from "icons";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(styles);

export default function CardInfo(props) {
  const classes = useStyles();

  const {
    marginTop,
    label,
    titulo,
    tituloSmall,
    color,
    footer,
    href,
    onClick,
    labelFooter,
    icono,
    botonHeader,
    accionBoton
  } = props;

  let colorCard = color ? color : "rose";
  return (
    <div>
      {marginTop && (
        <div>
          <br />
          <br />
        </div>
      )}

      <Card info>
        <CardHeader color={colorCard} stats icon>
          <CardIcon color={colorCard}>
            <Icon>{icono}</Icon>
          </CardIcon>
          <p className={classes.cardCategory}>{label}</p>
          <h3 className={classes.cardTitle}>
            {titulo}
            <small>
              {tituloSmall}
              {botonHeader && (
                <IconButton
                  className={classes.botonCard}
                  size="small"
                  aria-label={label}
                  onClick={() => accionBoton()}
                >
                  <ArrowForwardIcon />
                </IconButton>
              )}
            </small>
          </h3>
        </CardHeader>
        {footer && (
          <CardFooter stats>
            <div className={classes.stats}>
              <Danger>
                <Warning />
              </Danger>
              <a href={href} onClick={() => onClick()}>
                {labelFooter}
              </a>
            </div>
          </CardFooter>
        )}
      </Card>
    </div>
  );
}

CardInfo.propTypes = {
  titulo: PropTypes.string,
  children: PropTypes.node,
  marginTop: PropTypes.number,
  label: PropTypes.string,
  tituloSmall: PropTypes.string,
  color: PropTypes.string,
  footer: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  labelFooter: PropTypes.string,
  icono: PropTypes.string,
  botonHeader: PropTypes.bool,
  accionBoton: PropTypes.bool
};
